import { Button, type ButtonProps, Drawer, Stack } from '@mui/material'
import React from 'react'
import { useBoolean } from 'react-use'

import { AWSOnboardingForm } from 'components/getting-started/aws/AWSOnboardingForm'
import Icon, { type IconName } from 'components/Icon'
import { EditAuthenticationForm } from 'components/status-checks/edit/EditAuthenticationForm'
import { useObservabilityToolAuthenticationContext } from 'context/status-checks/ObservabilityToolAuthenticationContext'
import { type TeamExternalIntegration } from 'types/api/status-checks/status-check'

export const AWSAccountIdDrawer: React.FC<{
  buttonIcon?: IconName
  buttonProps?: ButtonProps
  buttonText?: string
  externalIntegrations: TeamExternalIntegration[]
  selectedAWSAccount?: TeamExternalIntegration
  renderButton?: (props: { openDrawer: () => void }) => React.ReactElement
}> = ({
  buttonIcon = 'plus',
  buttonText = 'Account ID',
  buttonProps,
  externalIntegrations,
  selectedAWSAccount,
  renderButton
}) => {
  const { setIsEdit } = useObservabilityToolAuthenticationContext()
  const [isOpen, setIsOpen] = useBoolean(false)
  const isEdit = selectedAWSAccount !== undefined

  const handleOpen = () => {
    setIsOpen(true)
    setIsEdit(isEdit)
  }

  const handleClose = () => {
    setIsOpen(false)
    setIsEdit(false)
  }

  return (
    <>
      {renderButton?.({ openDrawer: handleOpen }) ?? (
        <Button
          size="small"
          startIcon={buttonIcon ? <Icon icon={buttonIcon} /> : null}
          variant="contained"
          onClick={handleOpen}
          {...buttonProps}
        >
          {buttonText}
        </Button>
      )}
      <Drawer
        anchor="right"
        open={isOpen}
        PaperProps={{ sx: { width: 1200 } }}
        onClose={handleClose}
      >
        <Stack p={3}>
          {isEdit ? (
            <EditAuthenticationForm
              externalIntegration={selectedAWSAccount}
              externalIntegrations={externalIntegrations}
              handleCancel={handleClose}
            />
          ) : (
            <AWSOnboardingForm
              externalIntegrations={externalIntegrations}
              hasIntroText={false}
              onSuccess={handleClose}
            />
          )}
        </Stack>
      </Drawer>
    </>
  )
}
